// @flow
import { useFormikContext } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Radio from '../../../../../../../components/Radio/Radio';
import { useAppSelector } from '../../../../../../../reduxService/hooks';
import { SubSectorPosition } from '../../../../../enum/Sector';
import { selectProject } from '../../../../../selector/conversion';
import { IFormikFormSectors } from '../FormikSubsector';
import { getEmptySubsector } from '../../../../../utils/utils';
type Props = {};
export const RadioSubSectorBtns = (props: Props) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikFormSectors>();
    const project = useAppSelector(selectProject);

    return (
        <div>
            <div className='d-flex align-items-center gap-2'>
                {t('modal_subsector_subsectors_number')}
                <Radio
                    title='1'
                    name='subSectorNumber'
                    value={SubSectorPosition.Right}
                    checked={values[values.choosenSector].subSectorNumber === SubSectorPosition.Right}
                    onChange={() => {
                        setFieldValue(`${values.choosenSector}.subSectorNumber`, SubSectorPosition.Right);
                        const sectorFromProject = project.data?.geometry?.find(ele => ele.channel === values.choosenSector);
                        if (!!sectorFromProject && !!sectorFromProject.subSectors && sectorFromProject.subSectors.length > 0) {
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}`, sectorFromProject.subSectors[0]);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}.isTouched`, false);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}.isTouched`, false);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}.isTouched`, true);
                        } else {
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}`, getEmptySubsector(SubSectorPosition.Right, values[values.choosenSector]));
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}.isTouched`, false);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}.isTouched`, false);
                        }
                    }}
                />
                <Radio
                    title='2'
                    name='subSectorNumber'
                    value={SubSectorPosition.Left}
                    checked={values[values.choosenSector].subSectorNumber === SubSectorPosition.Left}
                    onChange={() => {
                        setFieldValue(`${values.choosenSector}.subSectorNumber`, SubSectorPosition.Left);
                        const sectorFromProject = project.data?.geometry?.find(ele => ele.channel === values.choosenSector);
                        if (!!sectorFromProject && !!sectorFromProject.subSectors && sectorFromProject.subSectors.length > 1) {
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}`, sectorFromProject.subSectors[SubSectorPosition.Left]);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}.isTouched`, false);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}.isTouched`, true);
                        } else {
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}`, getEmptySubsector(SubSectorPosition.Left, values[values.choosenSector]));
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}.isTouched`, false);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}.isTouched`, true);
                        }
                    }}
                />
                <Radio
                    title='3'
                    name='subSectorNumber'
                    value={SubSectorPosition.Center}
                    checked={values[values.choosenSector].subSectorNumber === SubSectorPosition.Center}
                    onChange={() => {
                        setFieldValue(`${values.choosenSector}.subSectorNumber`, SubSectorPosition.Center);
                        const sectorFromProject = project.data?.geometry?.find(ele => ele.channel === values.choosenSector);
                        if (!!sectorFromProject && !!sectorFromProject.subSectors && sectorFromProject.subSectors.length > 2) {
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}`, sectorFromProject.subSectors[0]);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}`, sectorFromProject.subSectors[SubSectorPosition.Left]);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}`, sectorFromProject.subSectors[SubSectorPosition.Center]);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}.isTouched`, true);
                        } else {
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}`, getEmptySubsector(SubSectorPosition.Right, values[values.choosenSector]));
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}`, getEmptySubsector(SubSectorPosition.Left, values[values.choosenSector]));
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}`, getEmptySubsector(SubSectorPosition.Center, values[values.choosenSector]));
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Left}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Center}.isTouched`, true);
                            setFieldValue(`${values.choosenSector}.${SubSectorPosition.Right}.isTouched`, true);
                        }
                    }}
                />
            </div>
        </div>
    );
};
